import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { useTurnAuthoritySnapshot } from './TurnAuthoritySnapshotContext'
import type { CartDisplayedPrice } from './TurnAuthoritySnapshotContext'

// Presentation contributes only the currently visible preview; checkout facts have
// a separate, always-mounted owner.
interface Props {
  cartItemPrices: ReadonlyArray<CartDisplayedPrice>
  visible: boolean
}

export function CartDisplaySnapshotRegistration({ cartItemPrices, visible }: Props) {
  const snapshotRef = useTurnAuthoritySnapshot()
  const owner = useRef(Symbol('cart display')).current

  useIsomorphicLayoutEffect(() => {
    snapshotRef.current.cartDisplayOwner = owner
    snapshotRef.current.displayedCartItemPrices = visible ? cartItemPrices : undefined
    return () => {
      if (snapshotRef.current.cartDisplayOwner !== owner) return
      snapshotRef.current.cartDisplayOwner = undefined
      snapshotRef.current.displayedCartItemPrices = undefined
    }
  }, [cartItemPrices, owner, snapshotRef, visible])
  return null
}
